import { CalendarDate } from '@internationalized/date';
import {
  LoadInput,
  LoadLineItemInput,
  WeightDisplayUnit,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createBrokeredLoadAtom = createMutationAtomFactory(
  'brokerage.createBrokeredLoad',
  (params: {
    expectedShipDate?: CalendarDate;
    salesOrderId?: string;
    bookingId?: string;
    supplierId: string;
    brokeredOrderId?: string;
    facilityId: string;
    deliveryNumber?: string;
    releaseNumber?: string;
    truckNumber?: string;
    trailerNumber?: string;
    containerNumber?: string;
    sealNumber?: string;
    lineItems?: LoadLineItemInput[];
    weightDisplayUnit?: WeightDisplayUnit | null;
    documentNumber?: string;
  }) => {
    const input: LoadInput = {
      facilityId: params.facilityId,
      supplierId: params.supplierId,
    };

    if (params.expectedShipDate)
      input.expectedShipDate = params.expectedShipDate.toString();
    if (params.salesOrderId) input.salesOrderId = params.salesOrderId;
    if (params.bookingId) input.bookingId = params.bookingId;
    if (params.brokeredOrderId) input.brokeredOrderId = params.brokeredOrderId;
    if (params.deliveryNumber) input.deliveryNumber = params.deliveryNumber;
    if (params.releaseNumber) input.releaseNumber = params.releaseNumber;
    if (params.truckNumber) input.truckNumber = params.truckNumber;
    if (params.trailerNumber) input.trailerNumber = params.trailerNumber;
    if (params.containerNumber) input.containerNumber = params.containerNumber;
    if (params.sealNumber) input.sealNumber = params.sealNumber;
    if (params.lineItems) input.lineItems = params.lineItems;
    if (params.weightDisplayUnit)
      input.weightDisplayUnit = params.weightDisplayUnit;
    if (params.documentNumber != null)
      input.documentNumber = params.documentNumber;

    return {
      tradeLoadCreate: {
        __args: {
          input,
        },
        id: true,
        status: true,
        expectedShipDate: true,
        supplierId: true,
        supplier: {
          id: true,
          name: true,
        },
        brokeredOrderId: true,
        brokeredOrder: {
          id: true,
          orderNumber: true,
        },
        salesOrderId: true,
        bookingId: true,
        facilityId: true,
        deliveryNumber: true,
        releaseNumber: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
